import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import LoginModal from '../common/log-in-modal'
import MessageModal from '../common/message-modal'
import ToastMessage from '../common/toast-message'
import Icon from '../icon'
import UnsuccessfulVerificationModal from '../kyc/unsuccessful-verification-modal'
import CasinoDrawerTabs from './casino-drawer-tabs'

type TabsProps = {
  closeProfileDrawer: () => void
  showProfileDrawer: () => void
}

const Tabs = ({ closeProfileDrawer }: TabsProps) => {
  const is_verified = useBoundStore(state => state.user.is_verified)
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const verif_request_count = useBoundStore(
    state => state.user.verif_request_count,
  )
  const username = useBoundStore(state => state.user.username)
  const { geoCheck } = useGeoCheck()
  const toastMessage = useModal(ToastMessage)
  const logInModal = useModal(LoginModal)
  const messageModal = useModal(MessageModal)
  const unsuccessfulVerificationModal = useModal(UnsuccessfulVerificationModal)
  const { t } = useTranslation(['common', 'drawer', 'kyc'])

  const TABS = [
    {
      icon: <Icon id="sports" />,
      label: t('sports', { ns: 'drawer' }),
      link: +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports',
      onLinkClick: () => {
        if (+pending_bind === 0 || +pending_bind === 2)
          setIsPendingDepositVisible(true)
      },
      isProtected: false,
    },
    {
      icon: <Icon id="casino" />,
      label: t('casino', { ns: 'drawer' }),
      link: '/casino',
      isProtected: false,
    },
    {
      icon: <Icon id="promotions" />,
      label: t('promotions', { ns: 'drawer' }),
      link: '/promotions',
      onLinkClick: () => null,
      isProtected: false,
    },
    // {
    //   icon: (
    //     <svg xmlns='http://www.w3.org/2000/svg' width='36.688' height='38.657' viewBox='0 0 36.688 38.657'>
    //       <path
    //         fillRule='evenodd'
    //         fill='#DF0033'
    //         d='M64.021,554.149a5.671,5.671,0,0,0-.763.142,6.56,6.56,0,0,0-.723.222,6.639,6.639,0,0,0-.763.364,2,2,0,0,1,.04-0.89,2.846,2.846,0,0,1,1.125-1.738,5.583,5.583,0,0,1,4.98-.525A3.748,3.748,0,0,1,69.8,553.4a4.578,4.578,0,0,1,.241,3.254,6.989,6.989,0,0,1-1.486,3.011,7.181,7.181,0,0,1-2.992,2.081,11.57,11.57,0,0,1-4.4.687,18.317,18.317,0,0,1-5.663-1.131,9.779,9.779,0,0,1-3.414-1.92,8.674,8.674,0,0,1-1.867-2.364,6.686,6.686,0,0,1-.743-2.284,7.316,7.316,0,0,1-.04-1.677,5.3,5.3,0,0,1,.5-1.5q0.422-.888.864-1.7,0.522-.971,1.164-1.981,0.321-.525.562-1.01a5.916,5.916,0,0,0,.321-0.889,1.524,1.524,0,0,0,0-.849,4.285,4.285,0,0,0-1-1.617,5.047,5.047,0,0,0-1.165-.848,4.262,4.262,0,0,0-1.406-.324,9.5,9.5,0,0,1-1.848-.242,9.662,9.662,0,0,1-1.425-.525,2.032,2.032,0,0,1-1.024-1.011,2.534,2.534,0,0,1-.3-1.414,6.626,6.626,0,0,1,.281-1.435q0.221-.708.462-1.354a3.311,3.311,0,0,0,.241-1.132,1.858,1.858,0,0,0-1.366-1.819,8.714,8.714,0,0,0-2.651-.363,2.618,2.618,0,0,0-1.245.343,0.7,0.7,0,0,0-.361.485v0.061a9.721,9.721,0,0,0,.14,1.455,3.445,3.445,0,0,1-.14,1.7,3.7,3.7,0,0,1-.542.91q-0.342.424-.582,0.788-0.321.525-.542,0.909a0.851,0.851,0,0,0-.181.5,0.507,0.507,0,0,0,.382.223,1.885,1.885,0,0,1,.462.141,0.576,0.576,0,0,1,.261.384,0.855,0.855,0,0,0,.3.465,1.791,1.791,0,0,1,.482.687,0.509,0.509,0,0,1,0,.283q0,0.322.04,0.768c0.027,0.242.06,0.519,0.1,0.828a6.813,6.813,0,0,0,.181.91,4.094,4.094,0,0,0,.562,1.475,1.322,1.322,0,0,0,.783.525,3.276,3.276,0,0,0,1.1.021,12.8,12.8,0,0,1,1.566-.081q0.683,0.041,1.406.04a2.539,2.539,0,0,1,1.285.323,2.343,2.343,0,0,1,.883.89,7.1,7.1,0,0,1,.522,1.131,12,12,0,0,1,.241,1.415,14.451,14.451,0,0,1,.12,1.859q0,0.808-.08,1.758a7.717,7.717,0,0,1-.4,1.879,5.654,5.654,0,0,1-2.008,2.829,7.212,7.212,0,0,1-2.852,1.213,8.371,8.371,0,0,1-3.052.081,9.586,9.586,0,0,1-2.611-.808,6.294,6.294,0,0,1-1.908-1.375,3.416,3.416,0,0,1-.9-1.616,3.7,3.7,0,0,1-.02-1.273,7.322,7.322,0,0,1,.3-1.213,7.487,7.487,0,0,1,.482-1.111c0.187-.351.348-0.687,0.482-1.011a4.789,4.789,0,0,0,.442-1.354,3.043,3.043,0,0,0,0-.99,2.132,2.132,0,0,0-.321-0.808q-0.361-.4-0.763-0.849-0.321-.4-0.683-0.869a4.616,4.616,0,0,1-.6-1.03,7.6,7.6,0,0,1-.843-3.072q0-.606.02-1.475a5.062,5.062,0,0,1,.3-1.637,6.29,6.29,0,0,1,1.185-1.718,29.494,29.494,0,0,0,2.109-2.768,8.414,8.414,0,0,0,.422-1.011,9.193,9.193,0,0,0,.281-0.97q0.1-.444.141-0.768a4.281,4.281,0,0,0,.04-0.444q0-.4-0.04-0.889c-0.027-.324-0.053-0.66-0.08-1.011,0-.161-0.013-0.431-0.04-0.808a4.639,4.639,0,0,1,.1-1.253,5.474,5.474,0,0,1,.5-1.394,3.789,3.789,0,0,1,2.55-1.9,9.737,9.737,0,0,1,1.546-.222,13.067,13.067,0,0,1,1.767.04,10.041,10.041,0,0,1,1.606-.444q0.723-.162,1.687-0.283a16.055,16.055,0,0,1,2.008-.122,16.22,16.22,0,0,1,5.864,1.072,12.863,12.863,0,0,1,3.9,2.424,10.525,10.525,0,0,1,2.33,3.112,16.788,16.788,0,0,1,1.165,3.113,13.623,13.623,0,0,1,.422,2.424c0.04,0.661.06,1,.06,1.031a2.206,2.206,0,0,0,.482,1.253,13.006,13.006,0,0,0,1.024,1.152q0.582,0.585,1.2,1.192a6.633,6.633,0,0,1,1.988,4.082,4.576,4.576,0,0,1-.321,2.142,4.66,4.66,0,0,1-1.125,1.6,8.966,8.966,0,0,1-1.466,1.111,9.1,9.1,0,0,1-1.365.687q-0.623.243-.783,0.324a6.638,6.638,0,0,0-2.028,1.333,3.911,3.911,0,0,0-.944,1.455,2.708,2.708,0,0,0-.1,1.415,2.423,2.423,0,0,0,.582,1.172,2.291,2.291,0,0,0,.723.606,3.961,3.961,0,0,0,.9.364,4.248,4.248,0,0,0,.884.141,2.185,2.185,0,0,0,.7-0.06,1.867,1.867,0,0,0,1.064-.586,1.9,1.9,0,0,0,.5-0.99,1.077,1.077,0,0,0-.221-0.89,1.231,1.231,0,0,0-1.064-.323h0Zm0,0'
    //         transform='translate(-33.531 -523.781)'
    //       />
    //     </svg>
    //   ),
    //   label: t('live-entertainment', { ns: 'drawer' }),
    //   link: '#',
    // },
  ] as const

  const kycBadge = useMemo(() => {
    if (is_verified === 0) {
      return (
        <p className="text-[#202632] text-[9px] bg-[#515151] px-[7px] py-[3px] rounded-xl">
          {t('verify', { ns: 'kyc' })}
        </p>
      )
    } else if (is_verified === 1) {
      return (
        <p className="text-[#202632] text-[9px] bg-[#58D66D] px-[7px] py-[3px] rounded-xl">
          {t('verified', { ns: 'kyc' })}
        </p>
      )
    } else if (is_verified === 2) {
      return (
        <p className="text-[#202632] text-[9px] bg-[#E9BF2E] px-[7px] py-[3px] rounded-xl">
          {t('in-review', { ns: 'kyc' })}
        </p>
      )
    } else if (is_verified === 3) {
      return (
        <p className="text-[#202632] text-[9px] bg-[#E74242] px-[7px] py-[3px] rounded-xl">
          {t('declined', { ns: 'kyc' })}
        </p>
      )
    }

    return null
  }, [is_verified])

  return (
    <div className="px-0 py-2.5 border-b-[#f5f6f9] dark:border-b-[#1f223c] border-b border-solid">
      {username && (
        <Link
          to={
            [3, 2, 1].includes(is_verified) || verif_request_count > 3
              ? undefined
              : '/profile/kyc'
          }>
          <div
            className="flx-btw-ctr px-5 py-2.5"
            onClick={() => {
              if (verif_request_count >= 3) {
                toastMessage.show({
                  text: t('contact-customer-service', { ns: 'kyc' }),
                })

                return
              }
              if (is_verified === 3) {
                unsuccessfulVerificationModal.show()
                closeProfileDrawer()
                return
              }
              if (is_verified === 2) {
                messageModal.show({
                  title: t('processing', { ns: 'kyc' }),
                  message: t('under-review', { ns: 'kyc' }),
                })
                return
              }
              if (is_verified === 1) {
                messageModal.show({
                  title: t('congratulations', { ns: 'common' }),
                  message: t('fully-verified', { ns: 'kyc' }),
                })

                return
              }
              closeProfileDrawer()
            }}>
            <div className="flx-str-ctr">
              <div className="flx-str-ctr relative w-10">
                <Icon className="w-[25px] h-[25px]" id="kyc" />
              </div>
              <span className="text-xs font-Syncopate-Bold uppercase text-txt">
                {t('kyc', { ns: 'drawer' })}
              </span>
            </div>
            {kycBadge}
          </div>
        </Link>
      )}
      {TABS.map((item, index) =>
        item.link === '/casino' ? (
          <CasinoDrawerTabs
            key={index}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : (
          <Link
            to={item.isProtected && !username ? undefined : item.link}
            key={index}>
            <div
              className="flx-str-ctr px-5 py-2.5"
              onClick={() => {
                closeProfileDrawer()
                if (item.isProtected && !username) geoCheck(logInModal.show)
                item.onLinkClick()
              }}>
              <div className="flx-str-ctr relative w-10 [&>svg]:w-[25px] [&>svg]:h-[25px]">
                {item.icon}
              </div>
              <span className="text-xs uppercase text-txt font-Syncopate-Bold">
                {item.label}
              </span>
            </div>
          </Link>
        ),
      )}
    </div>
  )
}

export default Tabs
